import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBlockCurrencySelect = _resolveComponent("SharedBlockCurrencySelect")!
  const _component_SharedBlockCurrencyPair = _resolveComponent("SharedBlockCurrencyPair")!
  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee")!
  const _component_WalletMain = _resolveComponent("WalletMain")!
  const _component_WalletHistory = _resolveComponent("WalletHistory")!
  const _component_WalletApplications = _resolveComponent("WalletApplications")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.b('title'))
    }, _toDisplayString(_ctx.$t("Кошелек")), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('wrapper'))
    }, [
      (_ctx.walletRepo.list.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.b('currency-section'), "currency-section"])
          }, [
            _createVNode(_component_SharedBlockCurrencySelect, {
              "buy-rate": _ctx.selectedPairBuyRate,
              "sell-rate": _ctx.selectedPairSellRate,
              onPairChanged: _ctx.handlePairChanged
            }, null, 8, ["buy-rate", "sell-rate", "onPairChanged"]),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.b('pairs'), { 'with-animation': _ctx.shouldAnimate }])
            }, [
              _createVNode(_component_Vue3Marquee, {
                duration: _ctx.shouldAnimate ? 30 : 0,
                pauseOnHover: true,
                gap: 20
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pairsWithRates, (pair) => {
                    return (_openBlock(), _createBlock(_component_SharedBlockCurrencyPair, {
                      key: pair.currency_id_from + pair.currency_id_to,
                      pair: pair,
                      "currency-map": _ctx.currencyMap
                    }, null, 8, ["pair", "currency-map"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["duration"])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_WalletMain),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('group'))
      }, [
        _createVNode(_component_WalletHistory, { history: _ctx.depositWithdrawalHistory }, null, 8, ["history"]),
        _createVNode(_component_WalletApplications, { history: _ctx.applicationHistory }, null, 8, ["history"])
      ], 2)
    ], 2),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isModalShow)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedModal), {
              key: 0,
              class: _normalizeClass(_ctx.b('modal')),
              modal: _ctx.walletRepo.modal,
              onUpdate: _ctx.loadData,
              onClose: _ctx.closeModal
            }, null, 40, ["class", "modal", "onUpdate", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}